import React from "react";
import cyboryx from "../assets/images/svg/cyboryx-text-img.svg";

const Cyboryx = () => {
  return (
    <>
      <section className="py-5 bg-light-white overflow-hidden">
        <div className="container py-xxl-5">
          <div className="row justify-content-center py-lg-2">
            <div className="col-lg-10 col-xxl-7">
              <div className="text-center">
                <div className="cyboryx-text-img" data-aos="fade-left">
                  <img
                    className="mb-xxl-3 w-100 pb-4 pb-5"
                    src={cyboryx}
                    alt="cyboryx-text-img"
                  />
                </div>
                <p
                  data-aos="fade-right"
                  className="font-sm fw-normal color-black  mb-3 mb-lg-4"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt
                  mollit anim id est laborum.
                </p>
                <p
                  data-aos="fade-left"
                  className="font-sm fw-normal color-black"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt
                  mollit anim id est laborum.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Cyboryx;
